import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "./ui/button";

const WelcomeBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissing, setIsDismissing] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("welcome_banner_dismissed");
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissing(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem("welcome_banner_dismissed", "true");
    }, 300); // Match animation duration
  };

  if (!isVisible) return null;

  return (
    <div
      className={`sticky top-0 left-0 right-0 z-10 bg-gradient-to-r from-blog-white to-background border-b border-blog-border shadow-sm transition-all duration-300 ${
        isDismissing ? "opacity-0 -translate-y-2" : "opacity-100 translate-y-0"
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 py-4 pr-12 relative">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleDismiss}
          className="absolute top-2 right-2 h-8 w-8 hover:bg-hover"
          aria-label="Dismiss welcome banner"
        >
          <X className="h-4 w-4" />
        </Button>

        <div className="text-sm leading-relaxed text-foreground">
          <p className="mb-2">
            <strong>Welcome.</strong> We’re building a platform to make after-school planning simpler for families.
            Follow along — or better still, add your input — as we shape this journey together. For more on the vision,
            start with our{" "}
            <a
              href="/?post=first"
              className="text-chat-red hover:underline font-medium"
              onClick={(e) => {
                e.preventDefault();
                // Trigger scroll to first post in blog list
                const firstPostLink = document.querySelector("[data-first-post]");
                if (firstPostLink) {
                  (firstPostLink as HTMLElement).click();
                }
              }}
            >
              first post.
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
